import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@/components/Header'
import Back from '@/components/Back'
import FixedBottom from '@/components/FixedBottom'
import CustomButton from '@/components/CustomButton'

interface StepIntroProps {
  onNext: () => void
  onBack: () => void
}

// 步骤列表数据（需要在组件内使用 t 函数）
const getSteps = (t: (key: string) => string) => [
  {
    icon: '/images/my/icons/step-intro-1.svg',
    title: t('填写个人信息'),
  },
  {
    icon: '/images/my/icons/step-intro-2.svg',
    title: t('上传证件'),
  },
  {
    icon: '/images/my/icons/step-intro-3.svg',
    title: t('上传手持证件照片'),
  },
]

export default function StepIntro({ onNext, onBack }: StepIntroProps) {
  const { t } = useTranslation()
  const steps = getSteps(t)
  const handleNext = useCallback(() => {
    onNext()
  }, [onNext])

  return (
    <div className="flex flex-col h-full">
      <Header
        leftChildren={<Back onClick={onBack} />}
      />

      <div className="flex-1 px-5 pt-4 pb-24">
        {/* 标题 */}
        <div className="text-7 font-medium text-[#1D2129] mb-3">
          {t('即将开始KYC验证')}
        </div>

        {/* 副标题 */}
        <p className="text-base text-[#9BA0AF] mb-6">
          {t('请提前准备好身份证或护照和手持证件照片按以下步骤完成资料填写')}
        </p>

        {/* 步骤列表 */}
        <div className="space-y-6">
          {steps.map((step, index) => (
            <div key={index} className="flex items-center gap-4">
              {/* 图标容器 */}
              <div className="flex items-center justify-center flex-shrink-0">
                <img src={step.icon} />
              </div>

              {/* 步骤标题 */}
              <span className="text-base text-[#1D2129]">{step.title}</span>
            </div>
          ))}
        </div>

        <div className="mt-6 bg-[#F9F9F9] p-4 rounded-4">
          <div className="text-sm font-medium text-[#1D2129] mb-4">{t('注意事项')}</div>
          <div className='text-xs text-[#667085] mt-3'>
            {t('持卡人注意事项1')}
          </div>
          <div className='text-xs text-[#667085] mt-3'>
            {t('持卡人注意事项2')}
          </div>
          <div className='text-xs text-[#667085] mt-3'>
            {t('持卡人注意事项3')}
          </div>
          <div className='text-xs text-[#667085] mt-3'>
            {t('持卡人注意事项4')}
          </div>
          <div className='text-xs text-[#667085] mt-3'>
            {t('持卡人注意事项5')}
          </div>
        </div>
      </div>

      {/* 底部按钮 */}
      <FixedBottom className="bg-white">
        <CustomButton onClick={handleNext}>
          {t('开始认证')}
        </CustomButton>
      </FixedBottom>
    </div>
  )
}

